const Life = () => {
  return <h1>Life & Fire Safety</h1>;
};

export default Life;
